import { getRequest, postRequest } from '../../services/httpService';

export function buildInitiateSSOUrl(redirectTo: string): string {
  return `pgta/initiate_sso?redirect_to=${encodeURIComponent(redirectTo)}`;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function initiateSSO(redirectTo: string): Promise<{ status: number; data: any }> {
  const url = buildInitiateSSOUrl(redirectTo);
  return getRequest(url); // axios wrapper should return { status, data }
}



export function buildProxyURL(endpoint: string, method = 'GET'): string {
  return `pgta/proxy?url=${encodeURIComponent(endpoint)}&method=${method}`;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function fetchViaProxy(endpoint: string, method = 'GET', ): Promise<{ status: number; data: any }> {
  const url = buildProxyURL(endpoint, method);
  return postRequest(url, {}, );
} 


export function buildInitiateSSOUrl2(redirectTo: string): string {
  let apiBase = '';
  const host = window.location.host;

  if (host === 'stage.vidaisolutions.com') {
    apiBase = 'https://stage-api.vidaisolutions.com';
  } else if (host === 'staging-use1.vidaisolutions.com') {
    apiBase = 'https://staging-use1-api.vidaisolutions.com';
  } else {
    // fallback or throw error
    apiBase = 'https://staging-use1-api.vidaisolutions.com';
  }

  return `${apiBase}/api/pgta/initiate_sso?redirect_to=${encodeURIComponent(redirectTo)}`;
}

type SSOResponse = {
  status: 'ok' | 'failed';
  location: string;
  msg: string;
};


// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function initiateSSO2(redirectTo: string): Promise<SSOResponse> {
  const url = buildInitiateSSOUrl2(redirectTo);
  return getRequest(url); // axios wrapper should return { status, data }
}


/**
 * API: GET embryo/pgt-results/{P_ID}/
 * Response item structure for PGT-A results
 */
export interface PgtResultsRecipient {
  id: number;
  cycle: number;
  day: number;
  grade: string | null;
  ai_grade?: string;
  ai_score?: number | string;
  action: string;
  embryo_number: number;
  pgt_results: unknown;
  pgt_result_notes: string;
  pgt_successful: boolean | null;
}

/**
 * Fetch recipients for PGT-A results
 * API: GET embryo/pgt-results/{P_ID}/
 */
export function getPgtResultsRecipients(P_ID: number): Promise<PgtResultsRecipient[]> {
  const url = `embryo/pgt-results/${P_ID}/`;
  return getRequest(url);
}